import React, { useState } from "react";
import * as yup from "yup";
import SearchLocation from "../../searchLocation";
import ItemsTransferHead from "./itemsTransferHead";
import ItemsTransfer from "./itemsTransfer";
import ItemsTransferCost from "./itemsTransferCost";
import DialogLayout from "../../../../../../partials/content/DialogLayout";
import { Formik } from "formik";
import { DialogActions } from "@material-ui/core";
import { onPreventEnterSubmitting } from "../../../../../../utils/utils";
import SearchWarehouseStocks from "../../../warehouses/searchWarehouseStocks";
import SearchOutletStocks from "../../../../sales/outlets/outletDetail/searchOutletStocks";
import {
  getItemsTransferRequest,
  saveItemsTransfer,
} from "../../../../../../services/inventory/itemsMovement";
import { Card } from "react-bootstrap";
import { TabView, TabPanel } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Editor } from "primereact/editor";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
const itemsTransferFormSchema = () => {
  return yup.object().shape({
    ID: yup.number(),
    transferToType: yup.number(),
    fromLocationType: yup.string(),
    fromLocationID: yup.number(),
    fromLocationName: yup.string().required("From Location is required"),
    toLocationType: yup.string(),
    toLocationID: yup.number(),
    toLocationName: yup.string().required("To Location is required"),
    moveDate: yup.date().required("Move Date is required"),
    currencyID: yup.number().when("totalCost", {
      is: (val) => (val > 0 ? true : false),
      then: yup
        .number()
        .required("Currency is required")
        .moreThan(0, "Currency is required"),
    }),
    currencyCode: yup.string().required("Currency is required"),
    totalCost: yup.number(),
    note: "",
    itemsTransfer: yup
      .array()
      .of(
        yup.object().shape({
          ID: yup.number(),
          itemID: yup.number(),
          itemName: yup.string().required("Item is required"),
          varCode: yup.string(),
          batchID: yup.number(),
          qtyStock: yup.number(),
          qty: yup
            .number()
            .transform((value) => (isNaN(value) ? 0 : value))
            .nullable()
            .required("Quantity is required")
            .moreThan(0, "Quantity cannot be zero or empty")
            .max(
              yup.ref("qtyStock"),
              "Transfered Quantity cannot be more than Stock Quantity"
            )
            .default(0),
          uomID: yup.number(),
          uom: yup.string(),
        })
      )
      .required("Transfer Items is required"),
    itemsTransferCost: yup.array().of(
      yup.object().shape({
        ID: yup.number(),
        costName: yup.string().required("Cost Name is required"),
        cost: yup.number().required("Cost is required"),
      })
    ),
  });
};
function ItemsTransferForm({
  accessedFrom = "",
  warehouse,
  outlet,
  onConfirmSave,
  onCloseDialog,
}) {
  const { companyProfile } = useGlobalData();
  const [openSearchFromLocation, setOpenSearchFromLocation] = useState(false);
  const [openSearchToLocation, setOpenSearchToLocation] = useState(false);
  const [openSearchStock, setOpenSearchStock] = useState(false);
  const [itemsTransferHead, setItemsTransferHead] = useState({
    accessedFrom: accessedFrom,
    transferToType: 1,
    fromLocationType: warehouse.ID > 0 ? "W" : outlet.ID > 0 ? "O" : "",
    fromLocationID:
      warehouse.ID > 0 ? warehouse.ID : outlet.ID > 0 ? outlet.ID : 0,
    fromLocationName:
      warehouse.ID > 0
        ? warehouse.warehouseName
        : outlet.ID > 0
        ? outlet.outletName
        : "",
    toLocationType: "",
    toLocationID: 0,
    toLocationName: "",
    moveDate: DateTime.now().startOf("day"),
    currencyID: companyProfile.currency.ID,
    currencyCode: companyProfile.currency.currencyCode,
    totalCost: 0,
    note: "",
    itemsTransfer: [],
    itemsTransferCost: [],
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeIndex1, setActiveIndex1] = useState(0);
  return (
    <React.Fragment>
      <Formik
        initialValues={itemsTransferHead}
        enableReinitialize={true}
        validateOnChange={false}
        validationSchema={itemsTransferFormSchema}
        onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
          if (
            values.fromLocationType === values.toLocationType &&
            values.fromLocationID === values.toLocationID
          ) {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Failed",
              text: "Cannot move to the same location!",
              icon: "error",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            setSubmitting(false);
          } else {
            values.currencyID = parseFloat(values.currencyID);
            values.totalCost = parseFloat(values.totalCost);
            values.itemsTransfer.forEach((item) => {
              item.qty = parseFloat(item.qty);
            });
            values.itemsTransferCost.forEach((cost) => {
              cost.cost = parseFloat(cost.cost);
            });
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            })
              .fire({
                title: "Are you sure want to save this Items Transfer ?",
                text: "Please note that you are responsible for this action",
                icon: "question",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
                cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                reverseButtons: true,
              })
              .then((result) => {
                if (result.isConfirmed) {
                  saveItemsTransfer(values).then((response) => {
                    Swal.mixin({
                      customClass: {
                        confirmButton:
                          "btn btn-success btn-md btn-pill btn-bold",
                      },
                      buttonsStyling: false,
                    }).fire({
                      title: "Saved",
                      html: response.data.message,
                      icon: "success",
                      showCloseButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                    });
                    onConfirmSave();
                  });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Cancelled",
                    text: "No change has been made",
                    icon: "info",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                }
              });
          }
        }}
      >
        {({
          values,
          status,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <form
            noValidate={true}
            autoComplete="off"
            className="kt-form"
            onSubmit={handleSubmit}
            onKeyDown={onPreventEnterSubmitting}
          >
            <div className="tabview mb-3">
              <div className="card">
                <TabView className="tabview" scrollable>
                  <TabPanel
                    header="Items Transfer Main"
                    rightIcon="fas fa-th-large"
                  >
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Card>
                          <Card.Header>
                            <i className="fas fa-window-maximize"></i>
                            <span>
                              <strong>Items Transfer Header</strong>
                            </span>
                          </Card.Header>
                          <Card.Body>
                            <ItemsTransferHead
                              onBlur={handleBlur}
                              onChange={handleChange}
                              values={values}
                              touched={touched}
                              errors={errors}
                              setFieldValue={setFieldValue}
                              onOpenSearchFromLocation={() => {
                                setOpenSearchFromLocation(true);
                              }}
                              onOpenSearchToLocation={() => {
                                setOpenSearchToLocation(true);
                              }}
                            />
                          </Card.Body>
                        </Card>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header="Note" rightIcon="fas fa-sticky-note">
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Editor
                          style={{ height: "250px", width: "100%" }}
                          onTextChange={(e) => {
                            setFieldValue("note", e.htmlValue);
                          }}
                          value={values.note}
                          placeholder="Type your notes here..."
                        />
                      </div>
                    </div>
                  </TabPanel>
                </TabView>
              </div>
            </div>
            <div className="accordion mb-3">
              <div className="card">
                <Accordion
                  className="accordion"
                  activeIndex={activeIndex}
                  onTabChange={(e) => {
                    setActiveIndex(e.index);
                  }}
                >
                  <AccordionTab
                    header={
                      <React.Fragment>
                        <i className="fas fa-sitemap"></i>
                        <span>
                          <strong>Transfer Items</strong>
                        </span>
                      </React.Fragment>
                    }
                  >
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <ItemsTransfer
                          values={values}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          touched={touched}
                          errors={errors}
                          setFieldValue={setFieldValue}
                          onOpenSearchStock={() => {
                            setOpenSearchStock(true);
                          }}
                        />
                      </div>
                    </div>
                  </AccordionTab>
                </Accordion>
              </div>
            </div>
            <div className="accordion">
              <div className="card">
                <Accordion
                  className="accordion"
                  activeIndex={activeIndex1}
                  onTabChange={(e) => {
                    setActiveIndex1(e.index);
                  }}
                >
                  <AccordionTab
                    header={
                      <React.Fragment>
                        <i className="far fa-money-bill-alt"></i>
                        <span>
                          <strong>Transfer Cost Items</strong>
                        </span>
                      </React.Fragment>
                    }
                  >
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <ItemsTransferCost
                          values={values}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          touched={touched}
                          errors={errors}
                          setFieldValue={setFieldValue}
                        />
                      </div>
                    </div>
                  </AccordionTab>
                </Accordion>
              </div>
            </div>
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  onCloseDialog();
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success btn-md btn-pill btn-bold"
                disabled={isSubmitting}
              >
                <i className="fas fa-save"></i>
                Save
              </button>
            </DialogActions>
            <DialogLayout
              open={openSearchFromLocation}
              title="Search From Location"
              onCloseDialog={() => {
                setOpenSearchFromLocation(false);
              }}
              fullScreen={false}
              maxWIdth="lg"
            >
              <SearchLocation
                onSelectLocation={(locationID, locationName, locationType) => {
                  setFieldValue("fromLocationType", locationType);
                  setFieldValue("fromLocationID", locationID);
                  setFieldValue("fromLocationName", locationName);
                  setFieldValue("itemsTransfer", []);
                  setOpenSearchFromLocation(false);
                }}
              />
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={() => {
                    setOpenSearchFromLocation(false);
                  }}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
              </DialogActions>
            </DialogLayout>
            <DialogLayout
              open={openSearchToLocation}
              title="Search Destination Location"
              onCloseDialog={() => {
                setOpenSearchToLocation(false);
              }}
              //fullScreen={false}
              maxWIdth="lg"
            >
              <SearchLocation
                locationType={
                  values.transferToType === 1 ? "Warehouses" : "Outlets"
                }
                onSelectLocation={(locationID, locationName, locationType) => {
                  if (
                    values.fromLocationType === locationType &&
                    values.fromLocationID === locationID
                  ) {
                    Swal.mixin({
                      customClass: {
                        confirmButton:
                          "btn btn-success btn-md btn-pill btn-bold",
                      },
                      buttonsStyling: false,
                    }).fire({
                      title: "Failed",
                      text:
                        "Destination Location cannot be the same with Source Location",
                      icon: "error",
                      showCloseButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                    });
                  } else {
                    setFieldValue("toLocationType", locationType);
                    setFieldValue("toLocationID", locationID);
                    setFieldValue("toLocationName", locationName);

                    async function getItemsTransferRequestData(
                      fwarehouseID = 0,
                      warehouseID = 0,
                      outletID = 0
                    ) {
                      const itemsTransferTmp = [];
                      const response = await getItemsTransferRequest(
                        fwarehouseID,
                        warehouseID,
                        outletID
                      );
                      const { data } = response.data;

                      for (const itemReserve of data.itemsReservation) {
                        itemsTransferTmp.push({
                          ID: 0,
                          journeyStockID: 0,
                          itemsReservationID: itemReserve.ID,
                          operationCardID: itemReserve.operationCardID,
                          itemID: itemReserve.itemID,
                          itemType: itemReserve.itemType,
                          itemTypeName: itemReserve.itemTypeName,
                          itemCode: itemReserve.itemCode,
                          itemName: itemReserve.itemName,
                          varCode: itemReserve.varCode,
                          batchID: itemReserve.batchID,
                          qtyStock: itemReserve.qty,
                          qty: itemReserve.qty,
                          uomID: itemReserve.uomID,
                          uomName: itemReserve.uomName,
                          delJourneyStock: false,
                          warehouseStocks: [],
                        });
                      }
                      setFieldValue("itemsTransfer", itemsTransferTmp);
                    }
                    let fwarehouseID = 0,
                      warehouseID = 0,
                      outletID = 0;

                    if (values.fromLocationType === "W") {
                      fwarehouseID = values.fromLocationID;
                    }
                    if (locationType === "O" && locationID > 0) {
                      outletID = locationID;
                    } else if (locationType === "W" && locationID > 0) {
                      warehouseID = locationID;
                    }
                    getItemsTransferRequestData(
                      fwarehouseID,
                      warehouseID,
                      outletID
                    );

                    setOpenSearchToLocation(false);
                  }
                }}
              />

              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={() => {
                    setOpenSearchToLocation(false);
                  }}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
              </DialogActions>
            </DialogLayout>

            <DialogLayout
              open={openSearchStock}
              title="Search Stock"
              onCloseDialog={() => {
                setOpenSearchStock(false);
              }}
              //fullScreen={false}
              maxWIdth="lg"
            >
              {values.fromLocationType === "W" ? (
                <SearchWarehouseStocks
                  warehouseID={values.fromLocationID}
                  onSelectStock={(stock) => {
                    let stockFound = false;
                    for (const item of values.itemsTransfer) {
                      if (item.batchID === stock.batchID) {
                        stockFound = true;
                        break;
                      }
                    }
                    if (!stockFound) {
                      const itemsTransferTmp = [...values.itemsTransfer];
                      itemsTransferTmp.push({
                        itemID: stock.itemID,
                        itemType: stock.itemType,
                        itemTypeName: stock.itemTypeName,
                        itemCode: stock.itemCode,
                        itemName: stock.itemName,
                        varCode: stock.varCode,
                        qty: 0,
                        batchID: stock.batchID,
                        uomName: stock.uom.uomName,
                        uomID: stock.uom.ID,
                        qtyStock: stock.qty,
                      });
                      setFieldValue("itemsTransfer", itemsTransferTmp);
                      setOpenSearchStock(false);
                    }
                  }}
                />
              ) : (
                <SearchOutletStocks
                  outletID={values.fromLocationID}
                  onSelectStock={(stock) => {
                    let stockFound = false;
                    for (const item of values.itemsTransfer) {
                      if (item.batchID === stock.batchID) {
                        stockFound = true;
                        break;
                      }
                    }
                    if (!stockFound) {
                      const itemsTransferTmp = [...values.itemsTransfer];
                      itemsTransferTmp.push({
                        itemID: stock.itemID,
                        itemType: stock.itemType,
                        itemTypeName: stock.itemTypeName,
                        itemCode: stock.itemCode,
                        itemName: stock.itemName,
                        varCode: stock.varCode,
                        qty: 0,
                        batchID: stock.batchID,
                        uomName: stock.uom.uomName,
                        uomID: stock.uom.ID,
                        qtyStock: stock.qty,
                      });
                      setFieldValue("itemsTransfer", itemsTransferTmp);
                      setOpenSearchStock(false);
                    }
                  }}
                />
              )}

              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={() => {
                    setOpenSearchStock(false);
                  }}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
              </DialogActions>
            </DialogLayout>
          </form>
        )}
      </Formik>
    </React.Fragment>
  );
}

export default ItemsTransferForm;
